module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAF0AAAARCAYAAAC/66DUAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAXaADAAQAAAABAAAAEQAAAABGzZ6kAAAA9klEQVRYCe3WPw6CMBQG8PcaTsEl0MXFyUE8hX8WNW54Aa9gGA0a0Qu4OWi8gBPxPNJngxKmkojBxPixlLbhe+kvTSkRHgj8gwD/wyK/tUZvePJNra2QLG673sZWV9kmMP6+ADM5IuKScNQYnce2BKDbZCqMJ7F/VMQBGXWtZWWDB3oF3LJPkr0fKqXmZfA408sEP5gzuzzQWi+JWJTiaRJ3ozwO6LlEDa0NPkP3BpcW8b1dQ11ECvfNbaaZ7XiiiTl+1k6mwulBhFwI1SEgr1BhYQpN54lu/qazlKlTR0lkFgLmZnMteniDAAQgAAEIQAACvyLwAOPxRgo61/r2AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/1x.png
// module id = UgQb
// module chunks = 3